let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("6mGQj")]).then(() => parcelRequire('7wKb0'));